import { ECategory } from '../../types/share';

export const CATEGORY_SALE = [
  { value: ECategory.FlatSale, label: 'Вторичка' },
  { value: ECategory.NewBuildingFlatSale, label: 'Первичка' },
  { value: ECategory.SuburbanSale, label: 'Загородная' },
];

export const CATEGORY_RENT = [
  { value: ECategory.FlatRent, label: 'Квартира — длительная аренда' },
  /**
   * TODO: CD-80512
   * Скрыли посуточную аренду для всех регионов
   * { value: ECategory.DailyFlatRent, label: 'Квартира — посуточная аренда' },
   */
  { value: ECategory.SuburbanRent, label: 'Загородная' },
];
